module.exports = __webpack_public_path__ + "media/images/front/favicon-8d0071618b9319d347041db3338a36b2.ico";